
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1537',
  depVersions: {
  "customer-portal-app": "static-1.1537",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.443",
  "data-fetching-client": "static-1.9395",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24518",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5309",
  "hs-test-utils": "static-1.7703",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9279",
  "hubspot-dlb": "static-2.1786",
  "hubspot-prosemirror": "static-1.17396",
  "hubspot-url-utils": "static-1.3873",
  "HubStyleTokens": "static-2.11142",
  "I18n": "static-7.1549",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6175",
  "payment-link-components": "static-1.22730",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6606",
  "quartz-core": "static-1.5825",
  "react": "static-7.176",
  "react-colorpicker": "static-2.9931",
  "react-dlb": "static-1.70",
  "react-utils": "static-2.5102",
  "rich-text-lib": "static-1.19329",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17478",
  "ui-components-test-utils": "static-1.5280",
  "UIComponents": "static-3.8089",
  "foundations-assets": "static-1.4550",
  "foundations-components": "static-1.7359",
  "foundations-theming": "static-1.4123",
  "foundations-theming-specialty": "static-1.1839",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9346",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.447",
  "quartz-config": "static-1.384",
  "quartz-routing": "static-1.36",
  "quick-fetch": "static-1.3655",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16352",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7858",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4463",
  "ui-addon-react-router-dom": "static-1.9265",
  "usage-tracker": "static-1.7053",
  "usage-tracker-anonymous": "static-1.5470",
  "usage-tracker-core": "static-1.6903",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3154",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2883",
  "quartz-webpack": "static-1.2830",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "commerce-analytics-service-client": "static-1.3408",
  "customer-data-objects": "static-1.7334",
  "frontend-preferences-client": "static-1.7643",
  "laboratory-lib": "static-3.6863",
  "onboarding-scopes": "static-1.6162",
  "rpc-client-utils": "static-1.4326",
  "ui-addon-opt": "static-4.8107",
  "HeadJS": "static-2.696",
  "hs-test-utils-bend-plugin": "static-1.2814",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3830",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7337",
  "cssUtils": "static-1.708",
  "customer-data-ui-utilities": "static-1.9544",
  "HubStyle": "static-2.11450",
  "knowledge-content-types": "static-1.8284",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.281",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.482",
  "ui-addon-emoji-picker": "static-1.9608",
  "ui-addon-i18n": "static-1.10847",
  "ui-business-units-lib": "static-1.8740",
  "ui-shepherd-react": "static-3.9862",
  "video-components-external": "static-1.10334",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4050",
  "commerce-tours-lib": "static-1.5602",
  "customer-data-properties": "static-1.50555",
  "getting-started-shared-tasks": "static-1.17680",
  "growth-onboarding-reliability": "static-1.4807",
  "onboarding-tours": "static-1.16159",
  "reference-resolvers-lite": "static-1.7808",
  "sales-checkout-service-client": "static-1.3420",
  "ui-addon-iframeable": "static-1.8740",
  "user-context": "static-1.4813",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.777",
  "hubspotter-http": "static-1.4405",
  "icons": "static-2.615",
  "mobile-manifest-mixins": "static-1.469",
  "quartz-auth": "static-1.281",
  "quartz-head": "static-1.271",
  "quartz-test": "static-1.281",
  "usage-tracker-container": "static-1.7043",
  "ui-fonts": "static-1.404",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9145",
  "data-token-picker": "static-1.15925",
  "FileManagerLib": "static-1.38312",
  "property-translator": "static-1.5132",
  "atom": "static-1.4790",
  "merchandise-lib": "static-1.255",
  "purchase-motions-components": "static-1.5355",
  "salesImages": "static-1.519",
  "self-service-api": "static-1.9946",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4226",
  "foundations-components-test-utils": "static-1.4842",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1068",
  "bend-plugin-foundations-components": "static-1.3628",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.1005",
  "bend-plugin-foundations-theming": "static-1.2606",
  "foundations-theming-base": "static-1.3108",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4193",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2832",
  "inbound-db-properties-service-client": "static-1.3605",
  "superstore": "static-1.4491",
  "feedback-loader": "static-1.28716",
  "ai-components-ui-library": "static-1.8154",
  "ui-addon-video-player": "static-1.8432",
  "ui-coaching-tips": "static-1.27751",
  "sassPrefix": "static-1.150",
  "react-dnd-compat": "static-1.4342",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2185",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7880",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4367",
  "content-media-composition-data-lib": "static-1.11174",
  "content-media-compositions": "static-2.15181",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3874",
  "magpie-lib": "static-1.5294",
  "magpie-types": "static-1.4754",
  "media-bridge-lib": "static-1.18447",
  "video-data-lib": "static-1.33992",
  "commerce-products-lib": "static-1.8622",
  "crm-message-bus": "static-1.42136",
  "growth-data-modal": "static-1.5052",
  "hubspot-apollo-client": "static-1.4598",
  "onboarding-tours-client": "static-1.4373",
  "calling-global-api": "static-1.63423",
  "calling-internal-common": "static-1.31007",
  "calling-lifecycle-internal": "static-1.64805",
  "calling-lifecycle-messages": "static-1.57099",
  "conditional-properties-service-client": "static-1.3549",
  "crm-links": "static-1.5970",
  "customer-data-objects-ui-components": "static-1.12721",
  "customer-data-property-utils": "static-1.7789",
  "external-options-client-types": "static-1.3909",
  "file-manager-components": "static-1.22672",
  "framework-data-schema-resolvers": "static-1.6587",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.380",
  "inbound-db-meta-service-client": "static-1.3386",
  "inbounddb-objects-service-types": "static-1.3976",
  "meetings-icalendar-utils-lib": "static-1.353",
  "multi-currency-client-types": "static-1.3444",
  "object-builder-ui-client": "static-1.47738",
  "pipeline-validation-client-types": "static-1.3713",
  "property-value-citations": "static-1.1169",
  "pulse": "static-1.214",
  "smart-property-lib": "static-1.5638",
  "tiered-pricing": "static-1.709",
  "ui-addon-form-validation": "static-1.10714",
  "growth-onboarding-confetti": "static-1.2770",
  "growth-onboarding-next-action-utils": "static-1.1213",
  "navigation-components": "static-1.17050",
  "onboarding-tours-utils": "static-1.225",
  "ui-shepherd-tracker": "static-1.7243",
  "ui-universal-auth": "static-1.8592",
  "batch-promise": "static-1.1249",
  "navigation-messaging": "static-1.6377",
  "getting-started-shared-tasks-store": "static-1.16798",
  "hubspotter-http-shared-msw-handlers": "static-1.9277",
  "audio-components": "static-1.5501",
  "FileManagerCore": "static-1.38171",
  "FileManagerImages": "static-1.35823",
  "video-components": "static-1.12337",
  "growth-monetization-service-types": "static-1.4242",
  "nav-client-types": "static-1.2051",
  "purchase-motions-api": "static-1.5358",
  "signup-constants": "static-1.18245",
  "signup-ui-url-generator": "static-2.7753",
  "trials-service-types": "static-1.3643",
  "chatspot-core": "static-1.20046",
  "chirp-fetch": "static-1.1600",
  "ContentUtils": "static-1.67410",
  "copilot-toolkit": "static-1.10342",
  "growth-onboarding-feedback-components": "static-1.6304",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.444",
  "simple-logging-lib": "static-1.2769",
  "customer-data-tracking": "static-1.6581",
  "products-iframe-lib": "static-1.7132",
  "products-ui-components-shared-msw-handlers": "static-1.9661",
  "hubspot-apollo-cache": "static-1.57",
  "calling-error-reporting": "static-1.31013",
  "shared-worker-versioning": "static-1.10736",
  "calling-usage-tracker": "static-1.6257",
  "calling-orchestration-shared-library": "static-1.34577",
  "conversations-skeleton-state": "static-1.6969",
  "location-customization-utils-lib": "static-1.8328",
  "crm-pipelines-api-client-types": "static-1.3891",
  "framework-builder-read-service-client": "static-1.3773",
  "framework-data-schema-quick-fetch": "static-1.6492",
  "persist-promise": "static-1.3406",
  "directed-graph": "static-1.655",
  "event-emitter": "static-1.644",
  "breeze-intelligence-kit": "static-1.5207",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9362",
  "fsm": "static-1.3449",
  "policy-lib": "static-1.6519",
  "react-tinymce": "static-1.54428",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9425",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53554",
  "tinymce-plugins": "static-1.56668",
  "tinymce-themes": "static-1.55524",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4252",
  "video-embed": "static-1.34826",
  "content-icons-ui": "static-1.2127",
  "social-insights-client-types": "static-1.21131",
  "eligibility-engine-service-types": "static-1.2924",
  "chatspot-client-types": "static-1.10377",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4525",
  "integrations-lib": "static-1.15185",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4012",
  "calling-orchestration-schema": "static-1.34802",
  "crm-record-cards-service-types": "static-1.3377",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4240",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2763",
  "interframe": "static-3.4510",
  "tinymce-data": "static-1.39639",
  "ui-addon-sales-email": "static-1.4932",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11898",
  "layout-dnd-utils": "static-1.10873",
  "react-codemirror": "static-1.10324",
  "ui-brand-identity-lib": "static-1.13507",
  "NamespacedHubStyle": "static-2.8824",
  "outpost": "static-1.3930",
  "flux-actions": "static-1.299",
  "integrations-error-boundary-lib": "static-1.12600",
  "integrations-tracking-lib": "static-1.5302",
  "native-integrations-shared-strings": "static-1.7507",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10091",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67485",
  "layout-data-lib": "static-1.9198",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2714",
  "advanced-menus-core": "static-1.14688",
  "advanced-menus-lib": "static-1.11677",
  "ExportDialog": "static-6.10107",
  "ui-memberships-settings-lib": "static-1.33236",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14687",
  "simple-menus-lib": "static-1.16204"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1537",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.443",
  "data-fetching-client": "/data-fetching-client/static-1.9395",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24518",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5309",
  "hs-test-utils": "/hs-test-utils/static-1.7703",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9279",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17396",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyleTokens": "/HubStyleTokens/static-2.11142",
  "I18n": "/I18n/static-7.1549",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6175",
  "payment-link-components": "/payment-link-components/static-1.22730",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6606",
  "quartz-core": "/quartz-core/static-1.5825",
  "react": "/react/static-7.176",
  "react-colorpicker": "/react-colorpicker/static-2.9931",
  "react-dlb": "/react-dlb/static-1.70",
  "react-utils": "/react-utils/static-2.5102",
  "rich-text-lib": "/rich-text-lib/static-1.19329",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17478",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5280",
  "UIComponents": "/UIComponents/static-3.8089",
  "foundations-assets": "/foundations-assets/static-1.4550",
  "foundations-components": "/foundations-components/static-1.7359",
  "foundations-theming": "/foundations-theming/static-1.4123",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1839",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9346",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.447",
  "quartz-config": "/quartz-config/static-1.384",
  "quartz-routing": "/quartz-routing/static-1.36",
  "quick-fetch": "/quick-fetch/static-1.3655",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16352",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7858",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4463",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9265",
  "usage-tracker": "/usage-tracker/static-1.7053",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5470",
  "usage-tracker-core": "/usage-tracker-core/static-1.6903",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3154",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2883",
  "quartz-webpack": "/quartz-webpack/static-1.2830",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3408",
  "customer-data-objects": "/customer-data-objects/static-1.7334",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7643",
  "laboratory-lib": "/laboratory-lib/static-3.6863",
  "onboarding-scopes": "/onboarding-scopes/static-1.6162",
  "rpc-client-utils": "/rpc-client-utils/static-1.4326",
  "ui-addon-opt": "/ui-addon-opt/static-4.8107",
  "HeadJS": "/HeadJS/static-2.696",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2814",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3830",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7337",
  "cssUtils": "/cssUtils/static-1.708",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9544",
  "HubStyle": "/HubStyle/static-2.11450",
  "knowledge-content-types": "/knowledge-content-types/static-1.8284",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.281",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9608",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10847",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8740",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9862",
  "video-components-external": "/video-components-external/static-1.10334",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4050",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5602",
  "customer-data-properties": "/customer-data-properties/static-1.50555",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17680",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4807",
  "onboarding-tours": "/onboarding-tours/static-1.16159",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7808",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3420",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8740",
  "user-context": "/user-context/static-1.4813",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.777",
  "hubspotter-http": "/hubspotter-http/static-1.4405",
  "icons": "/icons/static-2.615",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.469",
  "quartz-auth": "/quartz-auth/static-1.281",
  "quartz-head": "/quartz-head/static-1.271",
  "quartz-test": "/quartz-test/static-1.281",
  "usage-tracker-container": "/usage-tracker-container/static-1.7043",
  "ui-fonts": "/ui-fonts/static-1.404",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9145",
  "data-token-picker": "/data-token-picker/static-1.15925",
  "FileManagerLib": "/FileManagerLib/static-1.38312",
  "property-translator": "/property-translator/static-1.5132",
  "atom": "/atom/static-1.4790",
  "merchandise-lib": "/merchandise-lib/static-1.255",
  "purchase-motions-components": "/purchase-motions-components/static-1.5355",
  "salesImages": "/salesImages/static-1.519",
  "self-service-api": "/self-service-api/static-1.9946",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4226",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4842",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1068",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3628",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.1005",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2606",
  "foundations-theming-base": "/foundations-theming-base/static-1.3108",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4193",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2832",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3605",
  "superstore": "/superstore/static-1.4491",
  "feedback-loader": "/feedback-loader/static-1.28716",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8154",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8432",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27751",
  "sassPrefix": "/sassPrefix/static-1.150",
  "react-dnd-compat": "/react-dnd-compat/static-1.4342",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2185",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7880",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4367",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11174",
  "content-media-compositions": "/content-media-compositions/static-2.15181",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3874",
  "magpie-lib": "/magpie-lib/static-1.5294",
  "magpie-types": "/magpie-types/static-1.4754",
  "media-bridge-lib": "/media-bridge-lib/static-1.18447",
  "video-data-lib": "/video-data-lib/static-1.33992",
  "commerce-products-lib": "/commerce-products-lib/static-1.8622",
  "crm-message-bus": "/crm-message-bus/static-1.42136",
  "growth-data-modal": "/growth-data-modal/static-1.5052",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4598",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4373",
  "calling-global-api": "/calling-global-api/static-1.63423",
  "calling-internal-common": "/calling-internal-common/static-1.31007",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64805",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57099",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3549",
  "crm-links": "/crm-links/static-1.5970",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12721",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7789",
  "external-options-client-types": "/external-options-client-types/static-1.3909",
  "file-manager-components": "/file-manager-components/static-1.22672",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6587",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.380",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3386",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3976",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.353",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3444",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47738",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3713",
  "property-value-citations": "/property-value-citations/static-1.1169",
  "pulse": "/pulse/static-1.214",
  "smart-property-lib": "/smart-property-lib/static-1.5638",
  "tiered-pricing": "/tiered-pricing/static-1.709",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10714",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2770",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1213",
  "navigation-components": "/navigation-components/static-1.17050",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.225",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7243",
  "ui-universal-auth": "/ui-universal-auth/static-1.8592",
  "batch-promise": "/batch-promise/static-1.1249",
  "navigation-messaging": "/navigation-messaging/static-1.6377",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16798",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9277",
  "audio-components": "/audio-components/static-1.5501",
  "FileManagerCore": "/FileManagerCore/static-1.38171",
  "FileManagerImages": "/FileManagerImages/static-1.35823",
  "video-components": "/video-components/static-1.12337",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4242",
  "nav-client-types": "/nav-client-types/static-1.2051",
  "purchase-motions-api": "/purchase-motions-api/static-1.5358",
  "signup-constants": "/signup-constants/static-1.18245",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7753",
  "trials-service-types": "/trials-service-types/static-1.3643",
  "chatspot-core": "/chatspot-core/static-1.20046",
  "chirp-fetch": "/chirp-fetch/static-1.1600",
  "ContentUtils": "/ContentUtils/static-1.67410",
  "copilot-toolkit": "/copilot-toolkit/static-1.10342",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6304",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.444",
  "simple-logging-lib": "/simple-logging-lib/static-1.2769",
  "customer-data-tracking": "/customer-data-tracking/static-1.6581",
  "products-iframe-lib": "/products-iframe-lib/static-1.7132",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9661",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.57",
  "calling-error-reporting": "/calling-error-reporting/static-1.31013",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10736",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6257",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34577",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6969",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8328",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3891",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3773",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6492",
  "persist-promise": "/persist-promise/static-1.3406",
  "directed-graph": "/directed-graph/static-1.655",
  "event-emitter": "/event-emitter/static-1.644",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5207",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9362",
  "fsm": "/fsm/static-1.3449",
  "policy-lib": "/policy-lib/static-1.6519",
  "react-tinymce": "/react-tinymce/static-1.54428",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9425",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53554",
  "tinymce-plugins": "/tinymce-plugins/static-1.56668",
  "tinymce-themes": "/tinymce-themes/static-1.55524",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4252",
  "video-embed": "/video-embed/static-1.34826",
  "content-icons-ui": "/content-icons-ui/static-1.2127",
  "social-insights-client-types": "/social-insights-client-types/static-1.21131",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2924",
  "chatspot-client-types": "/chatspot-client-types/static-1.10377",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4525",
  "integrations-lib": "/integrations-lib/static-1.15185",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4012",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34802",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3377",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4240",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2763",
  "interframe": "/interframe/static-3.4510",
  "tinymce-data": "/tinymce-data/static-1.39639",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4932",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11898",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10873",
  "react-codemirror": "/react-codemirror/static-1.10324",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13507",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8824",
  "outpost": "/outpost/static-1.3930",
  "flux-actions": "/flux-actions/static-1.299",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12600",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5302",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7507",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10091",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67485",
  "layout-data-lib": "/layout-data-lib/static-1.9198",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2714",
  "advanced-menus-core": "/advanced-menus-core/static-1.14688",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11677",
  "ExportDialog": "/ExportDialog/static-6.10107",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33236",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14687",
  "simple-menus-lib": "/simple-menus-lib/static-1.16204"
}
};
